import { render } from "./QuestionsButton.vue?vue&type=template&id=1885af83"
import script from "./QuestionsButton.vue?vue&type=script&lang=ts"
export * from "./QuestionsButton.vue?vue&type=script&lang=ts"

import "./QuestionsButton.vue?vue&type=style&index=0&id=1885af83&lang=scss"
script.render = render

export default script